// Функція для отримання місця за допомогою геокодування
// Функція використовує Google Maps Geocoding API
// Використовується у trip-form.js для отримання координат за введеною адресою
// Використання:
// getPlaceByGeocode({ address: 'Some address' }, place => { console.log(place); });

export const getPlaceByGeocode = (address, callback) => {
  const lang = document.documentElement.lang || 'en';
  const geocoder = new google.maps.Geocoder();
  geocoder.language = lang;

  geocoder.geocode(address, (results, status) => {
    if (status === 'OK' && results[0]) {
      const place = {
        geometry: { location: results[0].geometry.location },
        formatted_address: results[0].formatted_address,
      };
      callback(place);
    }
  });
};
